import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import en from "./locales/en.json";
import fa from "./locales/fa.json";
import ku from "./locales/ku.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import bal from "./locales/bal.json";
import mzn from "./locales/mzn.json";
import glk from "./locales/glk.json";
import az from "./locales/az.json";

const resources = {
  en: {
    translation: en,
  },
  fa: {
    translation: fa,
  },
  ku: {
    translation: ku,
  },
  ar: {
    translation: ar,
  },
  fr: {
    translation: fr,
  },
  bal: {
    translation: bal,
  },
  mzn: {
    translation: mzn,
  },
  glk: {
    translation: glk,
  },
  az: {
    translation: az,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  debug: false, // Disable debug logging to reduce console noise
  lng: "en", // Set default language explicitly

  interpolation: {
    escapeValue: false, // React already does escaping
  },

  // RTL support
  supportedLngs: ["en", "fa", "ku", "ar", "fr", "bal", "mzn", "glk", "az"],

  // Namespace configuration
  defaultNS: "translation",
  ns: ["translation"],
});

export default i18n;
